import React from 'react';

import { globalFiltersRegistry } from 'config/globalFiltersConfiguration/globalFiltersMap';

import { IContract, IProject } from 'store/projectContract.store';

import {
    GlobalFilterConfigItem,
    GlobalFiltersState,
} from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';
import { Widget } from 'components/Dashboards/Reporting/reporting.types';
import classes from 'components/pages/ConfirmWidgetPage/components/WidgetGlobalFilters1/WidgetGlobalFilters.module.scss';
import { WidgetGlobalFiltersWrapper } from 'components/pages/ConfirmWidgetPage/components/WidgetGlobalFilters1/WidgetGlobalFiltersWrapper/WidgetGlobalFiltersWrapper';

interface Props {
    globalFilters: GlobalFiltersState;
    setGlobalFilters: React.Dispatch<React.SetStateAction<GlobalFiltersState>>;
    widgetGlobalFiltersConfig: GlobalFilterConfigItem[];
    latestVersionId: number | undefined;
    compareVersionId: number | undefined;
    selectedProject: IProject | null;
    selectedContract: IContract | null;
    widget?: Widget;
    componentKey?: string;
}

export const WidgetGlobalFilters = ({
    globalFilters,
    setGlobalFilters,
    widgetGlobalFiltersConfig,
    latestVersionId,
    compareVersionId,
    selectedProject,
    selectedContract,
    widget,
    componentKey,
}: Props) => {
    return (
        <div className={classes.widgetGlobalFIlters}>
            <WidgetGlobalFiltersWrapper
                defaultValues={globalFilters}
                setGlobalFilters={setGlobalFilters}
                selectedProject={selectedProject}
                selectedContract={selectedContract}
                widget={widget}
                componentKey={componentKey}
            >
                {widgetGlobalFiltersConfig.map((globalFilterConfig) => {
                    const GlobalFilterComponent = globalFiltersRegistry[globalFilterConfig.key];
                    if (!GlobalFilterComponent) return null;
                    return (
                        <GlobalFilterComponent
                            key={globalFilterConfig.key}
                            name={globalFilterConfig.name}
                            overrideLatestVersionId={latestVersionId}
                            overrideCompareVersionId={compareVersionId}
                            skipFormSet={true}
                        />
                    );
                })}
            </WidgetGlobalFiltersWrapper>
        </div>
    );
};
